// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";
const DataRangeStyle = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    color: colors.white,
    borderRadius: 16,
    shadowColor: colors.green,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
    marginTop: 10,
    marginBottom: 5,
    fontFamily: fonts.regular,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    flex: 1,
    color: colors.white,
    fontFamily: fonts.regular,
  },
  content: {
    paddingHorizontal: 8,
    paddingVertical: 8,
    marginBottom: 10,
    alignItems: "flex-start",
  },
  rowContainer: {
    marginBottom: 8,
    width: "100%",
    alignItems: "flex-start",
  },
  labelContainer: {
    width: "100%",
    alignItems: "flex-start",
    marginBottom: 4,
  },
  pickerContainer: {
    width: "100%",
    alignItems: "flex-start",
    marginBottom: 8,
  },
  label: {
    fontSize: 16,
    fontWeight: "bold",
    color: colors.green,
    fontFamily: fonts.regular,
    marginBottom: 4,
  },
  inputContainer: {
    width: "100%",
    alignItems: "flex-start",
  },
  materialContainer: {
    width: "100%",
    alignItems: "flex-start",
    marginBottom: 8,
  },
  input: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    fontSize: 16,
    borderWidth: 1,
    borderColor: colors.white,
    fontFamily: fonts.regular,
    width: "100%",
  },
  buttonContainer: {
    marginTop: 16,
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "bold",
    color: colors.white,
    fontFamily: fonts.regular,
  },
});

export default DataRangeStyle;
